import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from 'src/translations/i18n';

// Kreiranje Contexta
const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const storedLanguage = localStorage.getItem('selectedLanguage');

  const [language, setLanguage] = useState(storedLanguage || 'cir');

  const changeLanguage = (newLanguage) => {
    i18n.changeLanguage(newLanguage); // dodaj ovo

    setLanguage(newLanguage);
  };

  useEffect(() => {
    localStorage.setItem('selectedLanguage', language);
    localStorage.setItem('i18nextLng', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
